import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, AfterViewInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ActivatedRoute } from '@angular/router';
import { selectUserCredits } from '../../store/selectors/credits.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { selectPacks } from '../../store/selectors/packs.selectors';
import { selectSubscriptionPlans } from '../../store/selectors/subscription-plans.selectors';
import { loadUserCredits } from '../../store/actions/credits.actions';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { SubscriptionsProfileComponent } from './components/subscriptions-profile/subscriptions-profile.component';

@Component({
  selector: 'app-profil',
  imports: [CommonModule, UserProfileComponent, InputTextModule, SubscriptionsProfileComponent, DialogModule, TableModule, ButtonModule, ToggleSwitchModule, TextareaModule, DropdownModule, InputTextModule, SelectModule, TabsModule, DividerModule, AvatarModule, FormsModule, ImageModule, ToastModule, FileUploadModule, PasswordModule, CommonModule],
  templateUrl: './profil.component.html',
  styleUrl: './profil.component.scss',
  providers: [MessageService]
})
export class ProfilComponent implements AfterViewInit {
  constructor(private messageService: MessageService,
    private route: ActivatedRoute,
  ) { }
  private store = inject(Store);
  userCredits = toSignal(this.store.select(selectUserCredits))
  listOfPacks = toSignal(this.store.select(selectPacks))
  listOfPlans = toSignal(this.store.select(selectSubscriptionPlans));
  value_tap = signal<any>('0');

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      const success = params['tab'];
      if (success == 'subscription') {
        this.value_tap.set('2');
        const status = params['status'];
        if (status === 'true') {
          this.store.dispatch(loadUserCredits({ userId: JSON.parse(localStorage.getItem('user') || '{}').user_id }));
          setTimeout(() => {
            this.messageService.add({
              severity: 'success',
              summary: 'Paiement réussi',
              detail: 'Votre paiement a été traité avec succès !'
            });
          });
        } else if (status === 'false') {

          setTimeout(() => {
            this.messageService.add({
              severity: 'error',
              summary: 'Paiement échoué',
              detail: 'Une erreur est survenue lors du traitement de votre paiement.'
            });
          });
        }
      }

    });
  }
  openEmailClient() {
    window.location.href = 'mailto:contact@coteo-ia.com';
  }
}
